@if (error || erro403) {
@if(erro403){
<app-no-access></app-no-access>
}@else{

<div class="col-12">
  <div class="alert alert-danger" role="alert">{{ error }}</div>
</div>
}
} @else {

<div class="container-fluid">
  <!-- Cabeçalho -->
  <div class="row mb-4">
    <div class="col-12">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <h2 class="mb-1">
            <i class="fas fa-users me-2"></i>
            Clientes
          </h2>
          <p class="text-muted mb-0">Gerencie os clientes do sistema</p>
        </div>
        @if(!podeEditar){
        <button 
          type="button" 
          class="btn btn-primary"
          disabled
          title="Sem permissão"
        >
          <i class="fas fa-plus me-2"></i>
          Adicionar Cliente
        </button>
        }@else {
        <button 
          type="button" 
          class="btn btn-primary"
          [routerLink]="'/clientes/novo'"
        >
          <i class="fas fa-plus me-2"></i>
          Adicionar Cliente
        </button>
        }
      </div>
    </div>
  </div>

  <!-- Filtro de Quantidade por Página -->
  <div class="row mb-3" [formGroup]="filterForm">
    <div class="col-md-3">
      <label class="form-label">Itens por página</label>
      <select class="form-select form-select-sm" formControlName="Paginacao.QuantidadePorPagina">
        <option [ngValue]="10">10</option>
        <option [ngValue]="25">25</option>
        <option [ngValue]="50">50</option>
        <option [ngValue]="100">100</option>
      </select>
    </div>
  </div>

  <!-- Loading -->
  @if (clientService.loading) {
  <div class="text-center py-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Carregando...</span>
    </div>
    <p class="mt-2 text-muted">Carregando clientes...</p>
  </div>
  }

  <!-- Lista de Clientes -->
  @if (!clientService.loading) {
  <div class="card">
    <div class="card-header d-flex justify-content-between align-items-center">
      <h5 class="card-title mb-0">
        <i class="fas fa-list me-2"></i>
        Clientes ({{ paginacao.totalDeItens }})
      </h5>
    </div>
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-hover table-striped mb-0" [formGroup]="filterForm">
          <thead class="table-light">
            <tr>
              <th class="px-3 py-2">
                <div class="d-flex flex-column">
                  <span class="fw-bold mb-2">Nome</span>
                  <input type="text" class="form-control form-control-sm" placeholder="Filtrar"
                    formControlName="Nome" />
                </div>
              </th>
              <th class="px-3 py-2">
                <div class="d-flex flex-column">
                  <span class="fw-bold mb-2">Feira</span>
                  <input type="text" class="form-control form-control-sm" placeholder="Filtrar"
                    formControlName="Feiras" />
                </div>
              </th>
              <th class="px-3 py-2">
                <div class="d-flex flex-column">
                  <span class="fw-bold mb-2">Metro</span>
                  <input type="text" class="form-control form-control-sm" placeholder="Filtrar"
                    formControlName="Metro" />
                </div>
              </th>
              <th class="px-3 py-2 text-center">
                <div class="d-flex flex-column">
                  <span class="fw-bold mb-2">Status</span>
                  <input type="text" class="form-control form-control-sm" placeholder="Filtrar"
                    formControlName="Status" />
                </div>
              </th>
              <th class="px-3 py-2">
                <div class="d-flex flex-column">
                  <span class="fw-bold mb-2">Próximo Contato</span>
                  <input type="text" class="form-control form-control-sm" placeholder="Filtrar"
                    formControlName="Contato" />
                </div>
              </th>
              <th class="px-3 py-2 text-center">
                <div class="d-flex flex-column">
                  <span class="fw-bold mb-2">Habilitado</span>
                  <select class="form-control form-control-sm" formControlName="Habilitado">
                    <option value="">Todos</option>
                    <option value="Sim">Sim</option>
                    <option value="Não">Não</option>
                  </select>
                </div>
              </th>
              <th class="px-3 py-2 text-center">
                <span class="fw-bold">Ações</span>
              </th>
            </tr>
          </thead>
          <tbody>
            @if (clients.length === 0) {
            <tr>
              <td colspan="7" class="text-center py-5">
                <i class="fas fa-users fa-3x text-muted mb-3"></i>
                <h5 class="text-muted">Nenhum cliente encontrado</h5>
                <p class="text-muted">Tente ajustar os filtros ou clique em "Adicionar Cliente" para criar o primeiro cliente.</p>
              </td>
            </tr>
            }
            @if (clients.length > 0) {
            @for (row of clients; track $index) {
            <tr>
              <td class="px-3 py-2">{{ row.nome }}</td>
              <td class="px-3 py-2">
                @if (row.feiras.length) {
                <div [ngbTooltip]="getFeirasNomes(row.feiras)" placement="top" container="body" class="text-truncate">
                  {{ row.feiras[0].nome }}
                </div>
                }
              </td>
              <td class="px-3 py-2">
                @if (row.feiras.length) {
                <div [ngbTooltip]="getFeirasMetro(row.feiras)" placement="top" container="body" class="text-truncate">
                  {{ row.feiras[0].metroQuadrado || 0 }}
                </div>
                }
              </td>
              <td class="px-3 py-2 text-center">
                @if(row.status == 'temporario') {
                <span></span>
                } @else {
                @if (row.status) {
                <span class="badge text-opacity-100 {{ getStatusBadgeClass(row.status) }}">
                  {{ getStatusLabel(row.status) }}
                </span>
                }
                }
              </td>
              <td class="px-3 py-2">{{ row.proximocontato }}</td>
              <td class="px-3 py-2 text-center">
                @if (row.habilitado === 'Sim') {
                <span class="badge text-opacity-100 bg-success-subtle text-success">
                  Habilitado
                </span>
                }
                @if (row.habilitado === 'Não') {
                <span class="badge text-opacity-100 bg-danger-subtle text-danger">
                  Desabilitado
                </span>
                }
              </td>
              <td class="px-3 py-2 text-center">
                <div class="btn-group" role="group">
                  @if(!podeEditar){
                  <i title="Sem permissão" class="bx bx-block font-size-16 align-middle"></i>
                  }@else {
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-info"
                    [routerLink]="'/clientes/' + row.id"
                    title="Visualizar"
                  >
                    <i class="fas fa-eye"></i>
                  </button>
                  }
                </div>
              </td>
            </tr>
            }
            }
          </tbody>
        </table>
      </div>
    </div>
    
    <!-- Paginação -->
    @if (!clientService.loading && paginacao.totalDeItens > 0) {
    <div class="card-footer">
      <div class="row">
        <div class="col-sm-12 col-md-5">
          <div class="dataTables_info" role="status" aria-live="polite">
            Mostrando {{ (paginacao.paginaAtual - 1) * paginacao.quantidadePorPagina + 1 }} até
            {{ (paginacao.paginaAtual * paginacao.quantidadePorPagina) > paginacao.totalDeItens ? paginacao.totalDeItens : (paginacao.paginaAtual * paginacao.quantidadePorPagina) }} de
            {{ paginacao.totalDeItens }} registros
          </div>
        </div>
        <div class="col-sm-12 col-md-7">
          <div class="dataTables_paginate paging_simple_numbers d-flex justify-content-end">
            <ngb-pagination
              [page]="paginacao.paginaAtual"
              [pageSize]="paginacao.quantidadePorPagina"
              [collectionSize]="paginacao.totalDeItens"
              [maxSize]="5"
              [rotate]="true"
              [boundaryLinks]="true"
              (pageChange)="onPageChange($event)"
              class="pagination-rounded">
            </ngb-pagination>
          </div>
        </div>
      </div>
    </div>
    }
  </div>
  }
</div>
}